import { render } from "./notification-log-page.vue?vue&type=template&id=a1197b54"
import script from "./notification-log-page.vue?vue&type=script&lang=js"
export * from "./notification-log-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__